import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import { getMainStyle } from "../styles";
import PageLoader from "./PageLoader";
import { Main, StretchContainer } from "./utils";

const LayoutWithoutNav = () => {
  return (
    <Box sx={{ ...getMainStyle, padding: 0 }}>
      <StretchContainer maxWidth="xl">
        <Main>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </Main>
      </StretchContainer>
    </Box>
  );
};

export default LayoutWithoutNav;
